import { AppInventoryOption } from '@openx/types/targeting/appInventory';
import { TargetingFields } from '@openx/types/targeting/targeting';

export const useIsAppInventoryV2Enabled = observableTargeting => {
  const isOldInventory =
    Boolean(observableTargeting[TargetingFields.INVENTORY_AND_CONTENT]?.[AppInventoryOption.APP_BUNDLE_ID]) ||
    Boolean(observableTargeting[TargetingFields.INVENTORY_AND_CONTENT]?.[AppInventoryOption.APP_GROUP]);

  return !isOldInventory;
};
